<template>
  <section>
    <!-- Top menu -->
    <top-menu/>
    <!-- Content page -->
    <section>
      <div class="page-content">
        <div class="container-fluid">
          <div class="col-md-12 summary">
            <div class="header">
              <span class="header-title">
                <ion-icon name="card-outline"/>
                Resumo de cartões por empresa
              </span>
              <span class="header-subtitle">
                Veja todos os cartões que a empresa tem e já teve vinculados a ela
              </span>
            </div>
            <div class="body">
              <div class="body-form">
                <div class="form-text col-md-4">
                  <label>Buscar empresa</label>
                  <div class="form-input">
                    <input v-model="companyId" type="text" placeholder="ID ou nome da empresa"
                           autocomplete="off">
                    <ion-icon name="search-outline"></ion-icon>
                  </div>
                  <span v-if="validateForm" class="error-form">Campo obrigatório</span>
                </div>
                <button class="form-button" @click="getData()">Pesquisar</button>
              </div>
              <div class="body-details">
                <full-loading v-if="loading"/>
                <div v-else>
                  <div v-if="dataCode" class="details-content">
                    <div class="content-employee">
                      <span class="employee-name">{{ dataCode.name }}</span>
                      <span class="employee-id">{{ dataCode.companyId }}</span>
                      <div class="employee-cards">
                        <span>Total de cartões emitidos: <b>{{ dataCode.totalCards }}</b></span>
                      </div>
                      <div class="employee-status">
                        <div class="status-card" :style="{border: '1px solid #2ACC6B'}">
                          <span class="card-total" :style="{color: '#2ACC6B'}">{{ dataCode.totalActive }}</span>
                          <span class="card-label">Cartões ativos</span>
                        </div>
                        <div class="status-card" :style="{border: '1px solid #FF9900'}">
                          <span class="card-total" :style="{color: '#FF9900'}">{{ dataCode.totalBlocked }}</span>
                          <span class="card-label">Cartões bloqueados</span>
                        </div>
                        <div class="status-card" :style="{border: '1px solid #FF445D'}">
                          <span class="card-total" :style="{color: '#FF445D'}">{{ dataCode.totalCanceled }}</span>
                          <span class="card-label">Cartões cancelados</span>
                        </div>
                        <div class="status-card" :style="{border: '1px solid #7F8897'}">
                          <span class="card-total" :style="{color: '#7F8897'}">{{ dataCode.totalNotUsed }}</span>
                          <span class="card-label">Cartões não usados</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import topMenu from "../../../components/default/topMenu.vue";
import fullLoading from "../../../components/default/fullLoading.vue";
import {REQUEST_SERVICE, UTIL_SERVICE} from "../../../../../requestConfig";
import {COMPANY_SUMMARY} from "../../../../../urlConfig";
import swal from "sweetalert";

export default {
  name: "company-summary",
  components: {
    topMenu,
    fullLoading,
  },
  data() {
    return {
      loading: false,
      dataCode: '',
      companyId: '',
      validateForm: false,
    }
  },
  methods: {
    getData() {
      if (!this.companyId) {
        return this.validateForm = true
      } else {
        this.validateForm = false
      }

      this.loading = true

      REQUEST_SERVICE.get(COMPANY_SUMMARY + '/' + this.companyId)
        .then((response) => {
          UTIL_SERVICE.console("RESULT COMPANY_SUMMARY:", response.data);

          this.dataCode = response.data;
          this.loading = false;
        })
        .catch((reason) => {
          this.loading = false;
          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
    },
  },
  beforeMount() {

  }
}
</script>

<style lang="scss" scoped>

.summary {
  padding: 30px;
  background: #FFFFFF;
  border-radius: 10px !important;

  .header {
    padding-bottom: 10px;
    border-bottom: 1px solid #E6E9EC;

    .header-title {
      display: flex;
      align-items: center;
      font-size: 24px;
      font-weight: 700;
      color: #0F0F0F;

      ion-icon {
        margin-right: 10px;
      }
    }

    .header-subtitle {
      font-size: 14px;
      font-weight: 400;
      color: #3A424E;
    }
  }

  .body {
    margin-top: 25px;

    .body-form {
      .form-text {
        display: flex;
        flex-direction: column;
        padding: 0;
        position: relative;

        label {
          font-size: 14px;
          font-weight: 400;
          color: var(--border-gray);
        }

        .form-input {
          display: flex;
          position: relative;

          ion-icon {
            position: absolute;
            right: 10px;
            top: 10px;
            font-size: 16px;
            color: var(--dark-gray);
          }

          input {
            width: 100%;
            background: #EEF2F7;
            border-radius: 4px !important;
            padding: 6px 12px;
            border: 1px solid #EEF2F7;
            transition: .2s;

            font-size: 16px;
            font-weight: 400;
            color: var(--dark-gray);

            &::placeholder {
              font-size: 16px;
              font-weight: 400;
              color: var(--dark-gray);
            }

            &:hover {
              transition: .2s;
              border: 1px solid #cacaca;
            }

            &:focus-visible {
              outline: none;
              transition: .2s;
              border: 1px solid #cacaca;

              &::placeholder {
                transition: .1s;
                color: #EEF2F7;
              }
            }
          }
        }

        .error-form {
          position: absolute;
          right: 0;
          top: 8px;
          font-size: 11px;
          color: #FF445DFF;
          font-weight: 400;
        }
      }

      .form-button {
        background: #2F23D6;
        color: #ffffff;
        border-radius: 4px !important;
        border: none;
        padding: 9px 26px;
        margin: 25px 0 0 20px;

        &:hover {
          background: #20179e;
        }
      }
    }

    .body-details {
      .loader-page-content {
        box-shadow: none;
        padding-top: 20px;
        margin: 30px 0 0 0;
        border-top: 1px solid #E6E9EC;
      }

      .details-content {
        padding: 20px 0 58px 0;
        margin-top: 30px;
        border-top: 1px solid #E6E9EC;

        .content-employee {
          display: flex;
          flex-direction: column;
          align-items: center;

          .employee-name {
            font-weight: 700;
            font-size: 24px;
            color: #191919;
          }

          .employee-id {
            font-weight: 400;
            font-size: 14px;
            color: #7F8897;
          }

          .employee-cards {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 20px;
            width: 759px;
            height: 55px;
            background: #EEF2F7;
            border-radius: 10px !important;
            font-weight: 400;
            font-size: 11px;
            color: #3A424E;

            span {
              display: flex;
              align-items: center;

              b {
                margin-left: 10px;
                color: #191919;
                font-size: 28px;
                font-weight: 700;
              }
            }

          }

          .employee-status {
            display: flex;
            flex-direction: row;
            margin-top: 20px;

            .status-card {
              display: flex;
              align-items: center;
              justify-content: center;
              flex-direction: column;
              width: 168px;
              height: 71px;
              background: #EEF2F7;
              border-radius: 10px !important;
              margin-right: 30px;

              &:last-child {
                margin-right: 0;
              }

              .card-total {
                font-size: 24px;
                font-weight: 700;
                line-height: 140.62%;
              }

              .card-label {
                margin-top: 6px;
                font-weight: 400;
                font-size: 11px;
                color: #3A424E;
              }
            }
          }
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/benefits/cardsDetail/company-summary.vue